import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import client from "../api/client";

function ResendVerificationPage() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [error, setError] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setIsSubmitting(true);

    try {
      await client.post("/resend-verification", { email });
      navigate("/check-email");
    } catch (err) {
      if (err.response?.status === 404) {
        setError("No account found with that email address.");
      } else if (err.response?.status === 409) {
        setError("This account is already verified. Please log in.");
      } else {
        setError("Something went wrong. Please try again.");
      }
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <main className="AuthPage" style={{ maxWidth: "480px", margin: "0 auto" }}>
      <h1>Resend Verification Email</h1>
      <p style={{ opacity: 0.85, marginBottom: "24px" }}>
        Enter your email address and we'll send you a new verification link.
      </p>

      {error && <p className="error">{error}</p>}

      <form onSubmit={handleSubmit}>
        <label>
          Email
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
        </label>

        <button type="submit" disabled={isSubmitting}>
          {isSubmitting ? "Sending..." : "Send Verification Email"}
        </button>
      </form>

      <p style={{ marginTop: "16px" }}>
        <Link to="/login">← Back to Log In</Link>
      </p>
    </main>
  );
}

export default ResendVerificationPage;